<template>
    <div class="DirectorEmployeeView" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>Employees <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh" /></h2>
            <b-row style="padding-bottom:15px;">
                <b-col cols="6">
                    <label>Program:</label>
                    <select class="form-control" v-model="Program" @change="RefreshDataTable()">
                        <option :value="null">All</option>
                        <option v-for="subProgram in SubProgramList" :value="subProgram.value">{{subProgram.text}}</option>
                    </select>
                </b-col>
            </b-row>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="UserTableOptions.Fields"
                      :data-manager="DataManager"
                      class="vue-datatable"
                      pagination-path=""
                      :api-mode="false"
                      ref="datatable"
                      :row-class="onRowClass">
                <template slot="Name" scope="props">
                    <div class="TeamRecordName">
                        <span class="underline pointer" @click="ShowEmployeeModal(props.rowData)" v-html="props.rowData.Name"></span>
                    </div>
                    
                </template>
            </vuetable>
        </div>
        <div>
            <b-modal ref="EmployeeEditor-modal" title="" modal-class="fullscreen-modal" hide-footer>
                <div><EmployeeEditor :employee-view="EmployeeView" :user-list="UserList"></EmployeeEditor></div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import EmployeeEditor from '../Core/ItemEditors/EmployeeEditor.vue'
   //MIXINS
    import { TableScrollerSupport } from "../../mixins/TableScrollerSupport.js";
    
    import { EventBus } from '../../services/event-bus.js';
    export default {
        mixins: [
            TableScrollerSupport
        ],
        name: "DirectorEmployeeView",
        created() {
            let vm = this;
            EventBus.$on('update-employee-list', chartID => {
               vm.UpdateData(this.EmployeeView.UserId);
            });
        },
        beforeDestroy() {
            EventBus.$off('update-employee-list');
        },
        props: [],
        data: function () {
            return {
                search: '',
                Program: '',
                SubProgramIDs: [],
                SubProgramList: [],
                UserList: [],
                EmployeeView: {},
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
                UserTableOptions: {
                    Fields: [
                        {
                            name: '__slot:Name',
                            title: 'Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Role',
                            title: 'Role',
                            sortField: 'Role'
                        },
                        {
                            name: 'Supervisors',
                            title: 'Supervisor(s)',
                            sortField: 'Supervisors'
                        },
                        {
                            name: 'Security',
                            title: 'Security',
                            sortField: 'Security'
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetUsers();
            },
            GetUsers() {
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/DirectorGetUsers", { Program: this.Program, SubPrograms: this.SubProgramIDs }, this.GetUsersSuccess, () => { }, false);
            },
            GetUsersSuccess(response) {
                this.UserList = response.data.data;
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.UserList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;
            },
            ShowEmployeeModal(employee) {
                this.GetEmployeePrivateProfile(employee.UserID);
            },
           GetEmployeePrivateProfile(userID) {
                this.$MasterAPI.ExecuteRequest("GET", "Core/User/GetSpecifiedEmployeePrivateProfile", {userId: userID}, this.GetEmployeePrivateProfileSuccess, () => { }, true);
           },
            GetEmployeePrivateProfileSuccess(response) {
                this.EmployeeView = response.data.data;
                this.$refs['EmployeeEditor-modal'].show();
            },
            UpdateData(UserID) {
                this.RefreshDataTable();
                this.GetEmployeePrivateProfile(UserID);
                
            }
        },
        components: {
            Vuetable,
            EmployeeEditor
        },
        mounted() {
            //this.SubProgramList = this.$parent.UserPrivateProfile.AssignedSubPrograms;
            let vm = this;
            this.$parent.UserPrivateProfile.AssignedSubPrograms.forEach(function (sp) {
                vm.SubProgramList.push({ text: sp.Name, value: sp.Id });
                vm.SubProgramIDs.push(sp.Id);
            })
            //this.SubProgramByID();
            //this.asdf = this.$parent.UserPrivateProfile.AssignedSubPrograms;
            this.Program = this.$parent.UserPrivateProfile.AssignedSubPrograms[0].Id;
            this.GetUsers();
        },
    }
</script>

<style scoped>
    /deep/.fullscreen-modal .modal-dialog {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        position: relative;
        z-index: 100000;
    }
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>